
export const AMBIANCE_SOUNDS = {
  tibet: {
    sound: 'zen',
    credit: '© BluBonRelaXon / Pixabay',
    url: 'https://pixabay.com/fr/users/blubonrelaxon-10581343/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=138093'
  },
  marine: {
    sound: 'mer',
    credit: '© Michael Koreli / Pixabay',
    url: 'https://pixabay.com/fr/users/kokoreli777-39793239/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=169411'
  },
  night: {
    sound: 'nuit',
    credit: '© Georg Arnold / Pixabay',
    url: 'https://pixabay.com/fr/users/schorsch1964-51317703/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=374652'
  },
  campaign: {
    sound: 'love',
    credit: '© Semen Surin / Pixabay',
    url: 'https://pixabay.com/fr/users/sspsurvival-22364443/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=7715'
  },
  pluie: {
    sound: 'pluie',
    credit: '© DRAGON-STUDIO / Pixabay',
    url: 'https://pixabay.com/fr/users/dragon-studio-38165424/?utm_source=link-attribution&utm_medium=referral&utm_campaign=music&utm_content=437321'
  }
};
export const getAmbianceTemplates = (t) => [
  { id: 'tibet', label: `🧘 ${t('ambiance_card.tibet')}` },
  { id: 'marine', label: `🌊 ${t('ambiance_card.marine')}` },
  { id: 'night', label: `🌙 ${t('ambiance_card.night')}` },
  { id: 'campaign', label: `🌾 ${t('ambiance_card.campaign')}` },
 { id: 'pluie', label: `🌾 ${t('ambiance_card.pluie')}` },
];

export const AMBIANCE_IMAGES = {
  tibet: [
    { file: 'tibet1.jpg', credit: '© kuzy62 / Pixabay', url: 'https://pixabay.com/fr/users/kuzy62-9806863/?utm_source=link-attribution&utm_medium=referral&utm_campaign=image&utm_content=8621901' },
    { file: 'tibet2.jpg', credit: '© Pete Linforth / Pixabay', url: 'https://pixabay.com/fr/users/thedigitalartist-202249/?utm_source=link-attribution&utm_medium=referral&utm_campaign=image&utm_content=9107260' },
    { file: 'tibet3.jpg', credit: '© Sonali / Pixabay', url: 'https://pixabay.com/fr/users/jhollu7-42137680/?utm_source=link-attribution&utm_medium=referral&utm_campaign=image&utm_content=8993862' },
    { file: 'tibet4.jpg', credit: '© Adam Derewecki / Pixabay', url: 'https://pixabay.com/fr/users/derwiki-562673/?utm_source=link-attribution&utm_medium=referral&utm_campaign=image&utm_content=1409839' },
    { file: 'tibet5.png', credit: '© Ivana Tomášková / Pixabay', url: 'https://pixabay.com/fr/users/iffany-6128830/?utm_source=link-attribution&utm_medium=referral&utm_campaign=image&utm_content=8833960' },
  ],
  marine: [
    { file: 'ocean1.jpg', credit: '© eaozone / Pixabay', url: 'https://pixabay.com/fr/users/eaozone-367157/?utm_source=link-attribution&utm_medium=referral&utm_campaign=image&utm_content=1996408' },
    { file: 'ocean2.jpg', credit: '© Eddy_Blondey / Pixabay', url: 'https://pixabay.com/fr/users/eddy_blondey-14124309/' },
    { file: 'ocean3.jpg', credit: '© Norbert Höldin / Pixabay', url: 'https://pixabay.com/fr/users/hoeldino-1443037/?utm_source=link-attribution&utm_medium=referral&utm_campaign=image&utm_content=1079331' },
    { file: 'ocean4.jpg', credit: '© DenisDoukhan / Pixabay', url: 'https://pixabay.com/fr/users/denisdoukhan-607002/' },
    { file: 'ocean5.jpg', credit: '© PhotoJacques / Pixabay', url: 'https://pixabay.com/fr/users/photojacques-15061670/?utm_source=link-attribution&utm_medium=referral&utm_campaign=image&utm_content=5002472' },
  ],
  night: [
    { file: 'nuit1.jpg', credit: '© neelam279 / Pixabay', url: 'https://pixabay.com/fr/users/neelam279-9820894/' },
    { file: 'nuit2.jpg', credit: '© garten-gg / Pixabay', url: 'https://pixabay.com/fr/users/garten-gg-201217/' },
    { file: 'nuit3.jpg', credit: '© neelam279 / Pixabay', url: 'https://pixabay.com/fr/users/neelam279-9820894/' },
    { file: 'nuit4.png', credit: '© RosZie / Pixabay', url: 'https://pixabay.com/fr/users/roszie-6000120/' },
    { file: 'nuit5.jpg', credit: '© Darkmoon_Art / Pixabay', url: 'https://pixabay.com/fr/users/darkmoon_art-1664300/' },
  ],
  campaign: [
    { file: 'campagne1.jpg', credit: '© LesBains39 / Pixabay', url: 'https://pixabay.com/fr/users/lesbains39-24314339/' },
    { file: 'campagne2.jpg', credit: '© Roses_Street / Pixabay', url: 'https://pixabay.com/fr/users/roses_street-6652425/' },
    { file: 'campagne3.jpg', credit: '© Pixabay', url: 'https://pixabay.com/' },
    { file: 'campagne4.jpg', credit: '© Pixabay', url: 'https://pixabay.com/' },
    { file: 'campagne5.jpg', credit: '© Erich Westendarp / Pixabay', url: 'https://pixabay.com/fr/users/hpgruesen-2204343/' },
  ],
  pluie: [
    { file: 'pluie1.jpg', credit: '© BluetenKuss / Pixabay', url: 'https://pixabay.com/fr/users/bluetenkuss-27165192/' },
    { file: 'pluie2.jpg', credit: '© Larisa-K / Pixabay', url: 'https://pixabay.com/fr/users/larisa-k-1107275/' },
    { file: 'pluie3.png', credit: '© Ekletia / Pixabay', url: 'https://pixabay.com/fr/users/ekletia-41024362/' },
    { file: 'pluie4.png', credit: '© daydreamerscent / Pixabay', url: 'https://pixabay.com/fr/users/daydreamerscent-27897932/' },
    { file: 'pluie5.jpg', credit: '© Franz Bachinger / Pixabay', url: 'https://pixabay.com/fr/users/franz26-1553839/' },
  ]
};

export const generateAmbianceSVG = async (
  templateId,
  title,
  message,
  t,
  imageIndex = 0
) => {
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

  const defaultTitles = {
    tibet: t('ambiance_card.zen'),
    marine: t('ambiance_card.sea'),
    night: t('ambiance_card.good_night'),
    pluie: t('ambiance_card.pluie'),
    campaign: t('ambiance_card.nature'),
  };

  const emojis = {
    tibet: '🧘',
    marine: '🌊',
    night: '🌙',
    campaign: '🌾',
    pluie: '💧',
  };

  const textColors = {
    tibet: '#f7d794',
    marine: '#ffffff',
    night: '#dcdde1',
    campaign: '#f7d794',
    pluie: '#f7d794',
  };

  const messageColors = {
    tibet: '#ffffff',
    marine: '#ffffff',
    night: '#aaaaaa',
    campaign: '#ffffff',
    pluie: '#ffffff',
  };

  const finalTitle = title || defaultTitles[templateId];
  const msg = message || t('ambiance_card.default_message');

  // 🔥 récupérer image sélectionnée
 // const imageName = AMBIANCE_IMAGES[templateId][imageIndex];

const images = AMBIANCE_IMAGES[templateId] || [];
if (!images.length) {
  console.error('❌ aucune image pour', templateId);
  return '';
}
const safeIndex = imageIndex % images.length;

const { file, credit } = images[safeIndex];

  const toBase64 = (url) =>
    fetch(url)
      .then(res => res.blob())
      .then(blob => new Promise(resolve => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      }));

  //const imageBase64 = await toBase64(`${API_URL}/uploads/${imageName}`);
//const imageBase64 = await toBase64(`${API_URL}/uploads/${file}`);
let imageBase64 = '';

try {
  imageBase64 = await toBase64(`${API_URL}/uploads/${file}`);
} catch (e) {
  console.error('❌ image load failed:', file);
}

  // 🧠 wrap texte
  const wrapText = (text, maxChars = 50) => {
    const words = text.split(' ');
    const lines = [];
    let line = '';

    words.forEach(word => {
      const testLine = line ? `${line} ${word}` : word;
      if (testLine.length > maxChars) {
        lines.push(line);
        line = word;
      } else {
        line = testLine;
      }
    });

    if (line) lines.push(line);
    return lines;
  };

  const messageLines = wrapText(msg, 65);

  return `
<svg viewBox="0 0 600 400" xmlns="http://www.w3.org/2000/svg">

  <!-- Image de fond -->
  <image 
    href="${imageBase64}"
    x="0"
    y="0"
    width="600"
    height="400"
    preserveAspectRatio="xMidYMid slice"
  />

  <!-- Overlay sombre (lisibilité texte) -->
  <rect width="600" height="400" fill="rgba(0,0,0,0.35)" />

  <!-- Titre -->
  <text 
    x="300" 
    y="200" 
    text-anchor="middle" 
    font-size="36" 
    fill="${textColors[templateId]}"
    font-weight="bold"
  >
    ${emojis[templateId]} ${finalTitle}
  </text>

  <!-- Message -->
  <text 
    x="300" 
    y="240" 
    text-anchor="middle" 
    font-size="20" 
    fill="${messageColors[templateId]}" 
    opacity="0.9"
  >
    ${messageLines.map((line, i) => `
      <tspan x="300" dy="${i === 0 ? 0 : 28}">
        ${line}
      </tspan>
    `).join('')}
  </text>

</svg>`;
};
 // return templates[templateId] || templates['tibet'];
//};